/* The View PDF action sits at the far end of a document's action row, the way
   the Purchase Order page has always drawn it (piece 27). It opens the sheet in
   the browser's own PDF viewer (decision 0686), so it is a button drawn as the
   link it used to be, and the row's layout did not move when the action did. */
.pdf {
  margin-left: auto;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--navy-primary);
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

.pdf:focus-visible {
  outline: var(--focus-ring);
  outline-offset: var(--focus-ring-offset);
}

@media (pointer: coarse) {
  .pdf {
    min-height: var(--tap-target-min);
  }
}
